import React from 'react';

import {dateTimeYear} from './../DateFormats'

import component, {makePath, classnames} from '../component';
import Link from '../Link';
import TopBanner from '../TopBanner';
import HtmlContent from '../HtmlContent';
import {HBox, VBox} from '../Box';
import TypicalContent from '../TypicalContent';
import Banner from '../Banner';
import {Clock} from '../icons';
import Ellipsis from '../MultilineEllipsis';
import LoadMoreButton from '../LoadMoreButton';
import emptyPic from './../emptyPic';



export const NewsItem = component('NewsItem', function({data, type = 'Secondary', caption}) {
  if (!data) {
    return null;
  }

  const created = dateTimeYear(data.get('created_at'));

  const newsCls = classnames('NewsItem', `NewsItem--${type}`);

  const link = makePath('newsDetails',{
    id: data.get('id'),
    slug: data.get('slug')
  });

  return (
    <div className={newsCls}>
      {
        type === 'Review' && data.get('image') &&
          <div className="NewsItem-Bg" style={{
            backgroundImage: data.get('image') ? `url(${data.get('image')}?crop=1&w=608&h=440)` : 'none'
          }} />
      }
      {
        type === 'Main' && data.get('image') &&
          <Link href={link} className='NewsItem-Image' style={{
            backgroundImage: data.get('image') ? `url(${data.get('image')}?crop=1&w=608&h=440)` : 'none'
          }} />
      }
      {
        type === 'List' && data.get('image') &&
        <Link href={link} className='NewsItem-Image' style={{
            backgroundImage: data.get('image') ? `url(${data.get('image')}?crop=1&w=248&h=248)` : 'none'
          }} />
      }
      <div className='NewsItem-Content'>
        <div className='NewsItem-Type'>{caption || 'Новости'}</div>
         {
           type === 'Main' &&
            <Link href={link} className='NewsItem-Title'>
              <Ellipsis className="NewsItem-TitleEllipsis">{data.get('title')}</Ellipsis>
            </Link>
         }
        <Link href={link} className='NewsItem-Description'>
          <Ellipsis className="NewsItem-DescriptionEllipsis">{data.get('short_body')}</Ellipsis>
        </Link>
        <div className='NewsItem-Date'>
          <Clock className="NewsItem-Clock" />
          {created}
        </div>
      </div>
    </div>
  );
});

export const NewsItemHome = component('NewsItemHome', function({data}) {

  const created = dateTimeYear(data.get('created_at'));

  const link = makePath('newsDetails',{
    id: data.get('id'),
    slug: data.get('slug')
  });

  return (
    <div className='NewsItemHome'>
      {
        data.get('image') &&
        <Link href={link}>
          <img className='NewsItemHome-Image'
               src={data.get('image') ? `${data.get('image')}?resize=1&w=608` : emptyPic} />
        </Link>
      }
      <div className='NewsItemHome-Date'>{created}</div>
      <Link href={link} className='NewsItemHome-Brief'>
        {data.get('short_body')}
      </Link>
    </div>
  )
})

export default component('News', function({data, params}) {

  const news = data.cursor(['newsData', parseInt(params.id)]);

  const created = dateTimeYear(news.get('created_at'));

  return (
    <div>
      <TopBanner />
      <HBox isContainer={true} width={4}>
        <TypicalContent
          data={news}
          created={created}
          title={news.get('title')}
          image={news.get('image')}
          text={news.get('body')}
          advert={data.getIn(['banners', 'news_side']) ? <Banner width={256} height={432} data={data.getIn(['banners', 'news_side'])} type='vertical' /> : false}
          type="новости"
        />
      </HBox>
      <HBox width={4}>
        <VBox isContainer={true} width={2}>
          <NewsItem data={news.cursor('randomNews').get(0)} />
        </VBox>
        <VBox isContainer={true} width={2}>
          <NewsItem data={news.cursor('randomNews').get(1)} />
        </VBox>
      </HBox>
    </div>
  )
});



// WEBPACK FOOTER //
// ./src/components/pages/News.js